// components
import CommonActionModal from "../Common/CommonActionModal";
import TasksTab from "../Task/TasksTab";

// icons
import ListIcon from '@mui/icons-material/List';


class OpportunityEvaluationTaskModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: ListIcon,
            buttonLabel: this.props.label,
            buttonColor: 'neutral',
            modalLabel: 'Задачи',
            modalIcon: ListIcon,
            mainComponent: TasksTab,
            mainComponentProps: {
                phase: this.props.componentObj.id,
            },
            ready: true,
            flat: true,
        })
    }
}

export default OpportunityEvaluationTaskModal